import { urls } from '@/constants/urls';
import { useCurrentOrganisation } from '@/hooks/use-current-organisation';
import { useCurrentGroup } from './use-current-group';

export const useGroupUrl = () => {
  const { isUsingOrganisationOverride, organisation } =
    useCurrentOrganisation();
  const { data: group } = useCurrentGroup();
  const orgId = organisation?.id as number;
  const groupId = group?.id as number;
  return isUsingOrganisationOverride
    ? urls.organisations.organisation.groups.group.base.compose(orgId, groupId)
    : urls.groups.group.base.compose(groupId);
};
